
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import moment from 'moment'
import { Validator } from 'vee-validate'

@Component({
  components: {},
  inject: ['$validator'],
})
export default class DatePicker extends Vue {
  @Prop() public isPending: boolean
  @Prop() public textLabel!: string
  @Prop() public hasRange!: boolean
  @Prop() public defaultPicker!: string | undefined | null
  public account: any = {}
  public picker: string = ''
  private expiryDateMenu: boolean = false
  private today: string = ''
  private pickerMin: string = ''
  private maxDateAllowed: string = ''

  private mounted() {
    this.today = moment(new Date()).format('YYYY-MM-DD')
    if (this.defaultPicker !== undefined && this.defaultPicker !== null) {
      this.picker = moment(this.defaultPicker).format('YYYY-MM-DD')
    } else {
      this.picker = this.today
      this.$emit('updated-date', this.picker)
      this.$emit('input', this.picker)
    }
    this.pickerMin = this.hasRange === false ? '' : this.today
    this.maxDateAllowed = this.hasRange === false ? this.today : this.CompareDate(this.today)
  }

  private onChange() {
    this.$emit('updated-date', this.picker)
  }

  private updateDate() {
    this.$emit('input', this.picker)
    this.expiryDateMenu = false
  }

  private get formatDate() {
    return this.picker === undefined
      ? ''
      : (this as any).$moment(this.picker).format('L')
  }

  private CompareDate(date: string) {
    const currentYear = moment(new Date())
    if (moment(date).isBefore(`${currentYear.format('YYYY')}-07-31`, 'month')) {
      return moment(`${currentYear.format('YYYY')}-07-31`).format('YYYY-MM-DD')
    } else {
      return moment(
        `${currentYear.add(1, 'year').format('YYYY')}-07-31`,
      ).format('YYYY-MM-DD')
    }
  }
}
